<template>
  <div class="container">
    <img :src="licenceUrl" />
  </div>
</template>

<script>
export default {
  props: ['licenceUrl']
};
</script>

<style lang="stylus" scoped>
.container
  text-align center
  border 1px solid #ccc
  margin-bottom 20px
  padding 20px
  img
    width 280px
</style>
